import { graphql } from '@/gql';

graphql(`
  fragment GroceryStore on GroceryStoreType {
    id
    name
    slug
    logo
    storeId
    createdAt
    updatedAt
  }
`);
